// extracted by mini-css-extract-plugin
export default {"transactions":"transaction_transactions__CHf7I","chart":"transaction_chart__wYDvk"};